/**
 * The words of the backup alert (piece 9; decisions 4180, 4181): the to-do,
 * the text and the line the Backups stepper and the run list draw, kept beside
 * the rules that compose them so the one lookup stays one table.
 */
export const BACKUP_ALERT_STRINGS = {
  'settings.storage.alert.kind.mirror': 'The nightly mirror of changed files',
  'settings.storage.alert.kind.dump': 'The nightly database dump',
  'settings.storage.alert.failed': 'failed',
  'settings.storage.alert.partial': 'finished with failures',
  'settings.storage.alert.on': 'on',
  'settings.storage.alert.and': 'and',
  'settings.storage.alert.copiesFailed': 'copies failed, and each is on the System Errors page.',
  'settings.storage.alert.of': 'of',
  'settings.storage.alert.missed': 'has not succeeded since',
  'settings.storage.alert.missedTail': ', the hour it runs.',
  'settings.storage.alert.textLead': 'Backup alert:',
  'settings.storage.alert.textTail': 'Open Settings › Documents › Storage and Backups.',
  'settings.storage.alert.last': 'Last backup alert, sent to every super admin:',
  'settings.storage.alert.none': 'No backup alert has been sent.',
  'settings.storage.alert.runRaised': 'This run sent the backup alert to every super admin.',
} as const;
